import React from "react";
import "../styles/posts.css";
import ContactForm from "../../contact-form/contactForm";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { programInfo } from "./programsData";
import { useTranslation } from "react-i18next";

export default function Programs() {
	const { t } = useTranslation();

	return (
		<div className="singlePost events">
			<div className="singlePostWrapper">
				<h1 className="singlePostTitle">{t("programs.title")}</h1>
				<Helmet>
					<title>{t("programs.title")}</title>
					<meta name="description" content={t("programs.meta_desc")} />
				</Helmet>
				<div className="eventsGrid">
					{programInfo.map((program) => (
						<Link to={`/programs/${program.id}`} key={program.id}>
							<div className="eventCard">
								<h2 className="pb-10 text-align-center">
									{t(program.nameKey)}
								</h2>
								<img src={program.image} alt={t(program.nameKey)} />
								<h3 className="pb-10">{t(program.nameKey)}</h3>
								<p>{t(program.shortDescKey)}</p>
							</div>
						</Link>
					))}
				</div>
			</div>
			<div className="contact-form-container">
				<h3>{t("contact.heading")}</h3>
				<ContactForm />
			</div>
		</div>
	);
}

/*
import React from "react";
import "../styles/posts.css";
import ContactForm from "../../contact-form/contactForm";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom"; 
import { programInfo } from "./programsData";
import { useTranslation } from "react-i18next";

export default function Programs() {
	const { t } = useTranslation();
	
	return (
		<div className="singlePost events">
			<div className="singlePostWrapper">
				<h1 className="singlePostTitle">Програми</h1>
				<Helmet>
					<title>Програми</title>
					<meta
						name="description"
						content="Програми, които предлагам."
					/>
				</Helmet>	
				<div className="eventsGrid">
					{programInfo.map((program) => (
						<Link to={`/programs/${program.id}`} key={program.id}>
							<div className="eventCard">
								<h2 className="pb-10 text-align-center">{program.programName}</h2>
								<img src={program.programImage} alt={program.programName} />
								<h3 className="pb-10">{program.programShortName}</h3>
								<p>{program.programShortDesc}</p>
							</div>
						</Link>
					))}
				</div>
			</div>
			<div className="contact-form-container">
				<h3>Изпратете запитване</h3>
				<ContactForm />
			</div>
		</div>
	);
}
*/
